function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6,0 L1.2,0 C0.54,0 0.006,0.54 0.006,1.2 L0,10.8 C0,11.46 0.534,12 1.194,12 L8.4,12 C9.06,12 9.6,11.46 9.6,10.8 L9.6,3.6 L6,0 Z M7.2,9.6 L2.4,9.6 L2.4,8.4 L7.2,8.4 L7.2,9.6 Z M7.2,7.2 L2.4,7.2 L2.4,6 L7.2,6 L7.2,7.2 Z M5.4,4.2 L5.4,0.9 L8.7,4.2 L5.4,4.2 Z",
  id: "icon_file-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Doc",
  transform: "translate(-1.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_file",
  transform: "translate(1.500000, 0.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "icon_file-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#icon_file-path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero",
  xlinkHref: "#icon_file-path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "UI-Color-/-Active-Color-",
  mask: "url(#icon_file-mask-2)",
  fill: "#202020"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1.500000, 0.000000)",
  id: "Path"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0 0 14 0 14 14 0 14"
}))))));

function SvgIconFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "12px",
    viewBox: "0 0 11 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon_file.188b430b.svg";
export { ForwardRef as ReactComponent };